export default __webpack_public_path__ + "static/media/land-rover.0198f195.svg";